@if (filteredItems().length > 0) {
    <div
        *transloco="let t; prefix: 'uiResultFilter'"
        class="py-2 bg-alt">
        <div class="container">
            <div class="grid grid-cols-12 gap-x-3">
                @if (title) {
                    <h2 class="sr-only">
                        {{ title }}
                    </h2>
                }
                <div
                    #buttonWrapper
                    class="flex flex-wrap justify-center col-span-12 -mx-2 overflow-hidden lg:justify-start"
                    [ngClass]="{
                        'h-[48px]': !showAllFilters() && canToggleFiltersList(),
                        'lg:col-span-10': hasOverflow() || showAllFilters() && canToggleFiltersList(),
                        'lg:col-span-12': !(hasOverflow() || showAllFilters())
                    }">
                    <big-ui-button
                        [buttonStyle]="(filteredItems() | isActive).length === 0 ? 'smallActive' : 'smallDefault'"
                        [ariaLabel]="title + ': ' + t('all')"
                        (click)="clearFilters()">
                        {{ t('all') }}
                    </big-ui-button>
                    @for (item of filteredItems(); track item.facet) {
                        <big-ui-button
                            [buttonStyle]="item.isActive ? 'smallActive' : 'smallDefault'"
                            [ariaLabel]="title + ': ' + item.title"
                            (click)="toggleFilter(item)">
                            {{ item.title }}
                            @if (item.distribution) {
                                ({{ item.distribution }})
                            }
                        </big-ui-button>
                    }
                </div>
                @if (canToggleFiltersList() && (hasOverflow() || showAllFilters())) {
                    <div class="col-span-12 text-center lg:col-span-2 lg:justify-self-end">
                        <big-ui-button
                            [buttonStyle]="'smallLink'"
                            (click)="toggleFiltersList()"
                            [tabindex]="-1"
                            class="inline-block"
                            [classList]="['lg:px-3!', 'lg:block', 'lg:my-2', 'lg:text-right', 'lg:w-full', 'my-1', 'whitespace-nowrap']">
                            <span class="mr-1">{{ t(showAllFilters() ? 'showLess' : 'showMore') }}</span>
                            <big-icon
                                [icon]="iconAngleDown"
                                [size]="'w-4'"
                                [inline]="true"
                                class="translate-y-0.5 fill-primary"
                                [ngClass]="{
                                    'rotate-180': showAllFilters()
                                }" />
                        </big-ui-button>
                    </div>
                }
            </div>
        </div>
    </div>
}
